import { render, staticRenderFns } from "./IconDelay.vue?vue&type=template&id=5b631682&"
import script from "./IconDelay.vue?vue&type=script&lang=js&"
export * from "./IconDelay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports